<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <span class="back" @click="$router.go(-1)"><i class="el-icon-back"></i>&nbsp;&nbsp;&nbsp;&nbsp;返回</span>
            <div class="wrap" id="wrap" ref="wrap">
                <div class="content" v-loading="loading">
                    <div class="page" ref="container" id="page">
                        <div class="container" >
                            <div class="container-image" :id="'container-image' + index" v-for="(page, index) in pdfTemplate.pdfImagePaths" :key="index">
                                <img :src="page.imgUrl" alt="" />
                                <!-- 原来的签名区域 -->
                                <!-- <div class="singArea" :style="signStyle" v-if="pdfTemplate.pageNum==(index+1)" @click="signIt">
                                    <img :src="signFile64" v-if="signFile64" alt="">
                                    <span v-else>点击签名</span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fix">
                <div class="pageNum" v-if="pdfTemplate.pdfImagePaths">
                    <span>{{currentpage}}/{{pdfTemplate.pdfImagePaths.length}}</span>
                </div>
                <div class="signBtn">
                    <span class="onSubmit" @click="onSign">
                        我已阅读并同意
                    </span>
                </div>
            </div>
            <div class="zhe" v-if="progress">
                <div class="progress">
                    <el-progress type="circle" :percentage="percentage"></el-progress>
                </div>
            </div>
            <!-- 法人实名确认 -->
            <el-dialog
                title=""
                class="legalTipsDia"
                :visible.sync="legalTipsDia"
                width="420px"
            >
                <span>{{ legalTip }}</span>
                <div class="footer footer2">
                    <p class="agreement">
                        <el-checkbox v-model="checked2">我已阅读并同意</el-checkbox>
                        <a :href="realNameAgreement" target="_blank" @click="lookDoc">《实名认证服务协议》</a>
                        <a :href="privacyAgreement" target="_blank">《隐私保护协议》</a>
                    </p>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="legalTipsDia = false">取 消</el-button>
                    <el-button type="primary" @click="certify">立即认证</el-button>
                </span>
            </el-dialog>

            <el-dialog center :visible.sync="popShow" :close-on-click-modal="false" :close-on-press-escape="false">
                <div class="diaForm">
                    <div class="tip">
                        <i class="el-icon-warning"></i>
                        <p>需验证法定代表人与工商登记信息一致。</p>
                    </div>
                    <el-form :model="form" :rules="applyrules" ref="applyForm" >
                        <el-form-item
                            label="法定代表人"
                            label-width="130px"
                        >
                            <span style="color:cornflowerblue">{{form.legalName}}</span>
                        </el-form-item>
                        <el-form-item label="法人身份证号" label-width="130px" prop="idCardHidden" v-if="form.idCardHidden">
                            <el-input v-model="form.idCardHidden" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="法人身份证号" label-width="130px" prop="idCard" v-else>
                            <el-input v-model="form.idCard" autocomplete="off" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="法人手机号" label-width="130px" prop="legalPhone">
                            <el-input v-model="form.legalPhone" autocomplete="off" :disabled="isSession"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label-width="130px">
                            <span slot="label"><b style="color:#F56C6C;margin-right: 4px;">*</b>滑动验证</span>
                            <div style="padding-top:3px">
                                <Verification @verification="verification" ref="Verification" />
                            </div> 
                        </el-form-item> -->
                        <div class="yzm-item">
                            <el-form-item label="验证码:" label-width="130px" prop="code">
                                <el-input v-model="form.code" placeholder="短信验证码"></el-input>
                            </el-form-item>
                            <span :disabled="disabled" @click="getVerificationCode">{{ yzmtext }}</span>
                        </div>
                    </el-form>
                    <div class="footer">
                        <p class="agreement">
                            <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
                            <a :href="digitalCertificateAgreement" target="_blank">《数字证书服务协议》</a>
                        </p>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="popShow = false">取 消</el-button>
                    <el-button type="primary" @click="onSubmit('applyForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </el-row>
</template>

<script>
import {sendMsg,authImageInfo,generateAutographUploadInfo,entLegalStatus,legalInfoValidated,entLegalApply,entLegalInfo,identificationProtocol} from '@http/user_center/realName';
import { identification } from "@http/user_center/userInfo";
import { dataURLtoBlob, blobToFile } from '@/utils/filter';
//import Verification from "../../../components/VaVerification";
var interval = null;
export default {
    data() {
        var vphone = (rule, value, callback) => {
            if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error("手机号格式不正确"));
            }
            callback();
        };
        return {
            digitalCertificateAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/digitalCertificate',
            pdfTemplate:{}, 
            signStyle:{},
            percentage:0,
            currentRate:0,
            progress:false,
            signFile:'',
            signFile64:'',
            pdfScalHeight:'',
            currentpage:1,
            popShow:false,
            form:{
                legalName:'',
                idCard:'',
                legalPhone:'',
                code:'',
            },
            applyrules: {
                idCardHidden: [
                    {
                        required: true,
                        message: "请输入法人身份证号",
                        trigger: "blur",
                    },
                ],
                idCard: [
                    {
                        required: true,
                        message: "请输入法人身份证号",
                        trigger: "blur",
                    },
                ],
                legalPhone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur",
                    },
                    { validator: vphone, trigger: "blur" },,
                ],
                code:[
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur",
                    },
                ]
            },
            yzmtext: "获取验证码",
            disabled: false,
            currentTime: 60,
            verify: false,
            nvc:'',
            isSession:false,
            loading:true,
            checked:false,
            legalTipsDia:false,
            legalTip:'',
            checked2:false,
            realNameAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/realNameProtocol',
            privacyAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/privacy'
        };
    },

    components: {},

    computed: {},

    watch: {
      checked(newVal) {
          if(newVal){
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35028,
                },
            });
          }else{
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35029,
                },
            });
          }
      },
    },

    async created() {
        let res=await entLegalInfo();
        if(res.entStatus==0){
            this.$router.replace({
                path:'/userCenter/AuthenticationName'
            })
        }else if(res.entStatus==1){
            //企业已认证
            this.form=Object.assign({}, this.form, res);
        }
        identification().then((res) => {
            let status = res.authenticationStatus;
            if(status==7 && status==10){
                this.$router.replace({
                    path:"/userCenter/AuthenticationName",
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    },

    mounted() {
        this.init(() => {
            this.componentShow = true
            document.getElementById('wrap').addEventListener('scroll', this.scroll)
        });
    },

    methods: {
        //改版，有些方法用不上了，为了防止需求变更回去，占时留着。
        lookDoc(){
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35002,
                },
            });
        },
        isphoneNum(val){
            const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (!reg.test(val)) {
                return false;
            }
            return true
        },
        async init(callback){
            this.loading=true;
            let {pagePaths,pageNum,height,width,x,y}=await authImageInfo();
            // 计算签章大小，位置
            let { Width, Height } = await this.imageLoad(pagePaths[1])
            let containerWidth = this.$refs.container && this.$refs.container.getBoundingClientRect().width;
            let ratio = parseFloat((containerWidth / Width).toFixed(6));
            this.pdfScalHeight=Height*ratio;
            let scalWidth = width*ratio;
            let scalHeight = height*ratio;
            let contextX = x*ratio;
            let contextY = y*ratio;
            //整理pdf图片数据格式
            let pdfImagePaths=[];
            for (let key in pagePaths) {
                pdfImagePaths.push({imgUrl:pagePaths[key]});
            }
            this.pdfTemplate={
                pdfImagePaths,
                pageNum,
                scalHeight,
                scalWidth,
                contextX,
                contextY
            };
            this.signStyle={
                "top":contextY+'px',
                "left":contextX+'px',
                "width":scalWidth+'px',
                "height":scalHeight+'px',
                "lineHeight":scalHeight+'px',
            }
            this.loading=false;
            callback && callback();
        },
        imageLoad (url) {
			return new Promise((resolve, reject) => {
				var img = new Image()
				img.src = url
				img.onload = function () {
					resolve({
						Width: img.width / 2,
						Height: img.height / 2
					})
				}
				img.onerror = function () {
					reject()
				}
			})
		},
        signIt(){
            this.$TsaSignName.show({
                // type: 'blob',
                ratio: this.pdfTemplate.scalWidth/this.pdfTemplate.scalHeight,
                onChange: (val) => {
                    this.signFile64=val;
                    this.loading=true;
                    this.signFile = blobToFile(dataURLtoBlob(val), new Date().getTime() + '.png');
                    // console.log(this.signFile);
                    this.$TsaSignName.hide()
                    this.loading=false;
                }
            })
        },
        scroll (e) {
            let scrollTop = e.target.scrollTop
            let clientHeight = e.target.clientHeight
            let scrollHeight = e.target.scrollHeight
            let scrollDistance = 0
            let pdfImagePaths=this.pdfTemplate.pdfImagePaths;
            for(let i = 0; i < pdfImagePaths.length; i++) {
                scrollDistance = scrollDistance + this.pdfScalHeight + 5
                if (scrollTop + clientHeight >= scrollHeight) {
                    this.currentpage = pdfImagePaths.length
                    break
                } else if (scrollTop < scrollDistance) {
                    this.currentpage = i + 1
                    break
                }
            }
        },
        gotoLoaction(){
            let el = this.$refs.wrap;
            let scrollTop=(this.pdfTemplate.pageNum-1)*this.pdfScalHeight+5;
            el.scrollTop = scrollTop;
        },
        async onSign(){
            // 原来的法人签名逻辑
            // this.$TsaWebTrace.post({
            //     data: {
            //         "eventId": 35027,
            //     },
            // });
            // let {legal,status}=await entLegalStatus();
            // this.legalTip= legal? `法定代表人（${legal}）尚未实名认证，请先实名认证。` : `法定代表人 尚未实名认证，请先实名认证。`
            // if(status==0){
            //     this.legalTipsDia=true;
            // }else{
            //     if(this.signFile){
            //         this.form.legalName=legal;
            //         this.popShow=true;
            //     }else{
            //         this.$msg('请在指定位置进行签名','info');
            //         this.gotoLoaction();
            //     }
            // }
            this.$router.push({path:'/userCenter/realName/personalInfo'})
        },
        certify(){
            if(!this.checked2){
                this.$msg("请先阅读并勾选协议");
                return false;
            }
            identificationProtocol().then(()=>{
                this.$router.push({path:'/userCenter/realName/personalInfo'})
            }).catch((err) => {
                this.$msg("协议签署服务失败");
            });
        },
        onSubmit(form){
            let that=this;
            this.$refs[form].validate(async (valid) => {
                if (valid) {
                    if (!this.verify) {
                        this.$msg("请先进行滑块验证");
                        return false;
                    }
                    if(!this.checked){
                        this.$msg("请先阅读并勾选协议");
                        return false;
                    }
                    this.form.legalPhone = this.form.legalPhone.replace(/\s*/g,"");
                    this.form.idCard = this.form.idCard.replace(/\s*/g,"");
                    this.form.code = this.form.code.replace(/\s*/g,"");
                    this.$TsaWebTrace.post({
                        data: {
                            "eventId": 35030,
                            "logParam":{
                                'phone':that.form.legalPhone,
                                'userName':that.form.legalName,
                                'idCard':that.form.idCard,
                                'code':that.form.code,
                            }
                        },
                    });
                    try {
                        await legalInfoValidated(this.form);
                        this.popShow=false;
                        generateAutographUploadInfo().then((oss)=>{
                            this.$request({
                                method: "PUT",
                                url: oss.uploadUrl,
                                data:this.signFile.slice(0, this.signFile.size),
                                timeout:86400000,
                                headers: {
                                    'content-type':'application/octet-stream'
                                },
                                onUploadProgress:function(progressEvent){
                                    that.progress = true;
                                    that.percentage =((progressEvent.loaded / progressEvent.total) * 100) | 0
                                }
                            }).then(async () => {
                                try {
                                    await entLegalApply({autographPath:oss.storageUrl});
                                    sessionStorage.clear();
                                    that.$router.replace({
                                        path:'/userCenter/realName/enterpriseSuccess'
                                    })
                                } catch (error) {
                                    that.progress = false;
                                    that.percentage=0;
                                    that.currentRate=0;
                                }
                            }).catch((err) => {
                                console.log(err);
                            });
                        })
                    } catch (error) {
                        console.log(error);
                    } 
                }
            })
            
        },
        async verification(data) {
            let that = this;
            if (data) {
                this.verify=data.verify;
                this.nvc=data.nvc;
                window.nvc.getNVCValAsync(async (nvcVal)=> {
                    let { legalPhone } = that.form;
                    if (!legalPhone) {
                        that.$msg("联系人手机号不能为空");
                        that.$refs.Verification.resetNvc();
                        that.verify=false;
                        return false;
                    }
                    let reg = /^1[3456789]\d{9}$/;
                    if (!reg.test(legalPhone)) {
                        that.$msg("手机号格式不正确");
                        that.$refs.Verification.resetNvc();
                        that.verify=false;
                        return false;
                    }
                    that.getVerificationCode();
                });
            }
        },
        async getVerificationCode() {
            var that = this;
            if (!this.verify) {
                this.$msg("请先进行滑块验证");
                return false;
            }
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35022,
                    "logParam":{
                        'phone':that.form.legalPhone
                    }
                },
            });
            this.getCode();
            that.disabled = true;
            try {
                let res = await sendMsg({
                    nvc: that.nvc,
                    phone: that.form.legalPhone
                });
                that.$msg(res.message,'success');
                that.verify = true;
            }catch (err) {
                that.$msg('发送失败')
                that.$refs.Verification.resetNvc();
                clearInterval(interval);
                that.yzmtext = "获取验证码";
                that.disabled = false;
                that.verify = false;
            }
        },
        getCode() {
            var that = this;
            var currentTime = that.currentTime;
            interval = setInterval(function() {
                currentTime--;
                that.yzmtext = "(" + currentTime + "s)重新获取";
                if (currentTime <= 0) {
                    clearInterval(interval);
                    that.yzmtext = "重新获取";
                    that.currentTime = 60;
                    that.disabled = false;
                }
            }, 1000);
        },
    },
};
</script>
<style lang="less" scoped>
.main_block{
    display: flex;
}
.mianContent{
    flex: 1;
    position: relative;
    padding:0;
    .back{
        position:absolute;
        right: 30px;
        top:-30px;
        font-size: 14px;
        cursor: pointer;
        &:hover{
            color:#10A0E9
        }
    }
}
.fix{
    position: absolute;
    top: 35px;
    right: 5%;
    display: flex;
    align-items: center;
    .pageNum {
        width: 60px;
        border-radius: 5px;
        background: #949494;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 13px;
        color: #fff;
        margin-right: 20px;
    }
    .signBtn{
        span{
            display: inline-block;
            width: 130px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            border-radius: 5px;
            border:1px solid #10A0E9;
            cursor: pointer;
            background:#10A0E9;
            color: #fff;
            opacity: .7;
            &:hover{
                opacity: 1;
            }
        }
    }
}

.wrap{
    width: 100%;
    height:calc(100vh - 102px);
    margin:0 auto;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    padding-top:18px;
    box-sizing: border-box;
    position: relative;
    .content {
        width: 60%;
        margin:0 auto;
        box-sizing: border-box;
        min-height: 100%;
        .page {
            height: 100%;
            .container-image{
                position: relative;
                width: 100%;
                margin-bottom: 5PX;
                img{
                    height: auto;
                    max-width: 100%;
                }
                .singArea{
                    position: absolute;
                    border:1px dashed #EF8412;
                    box-sizing: border-box;
                    cursor: pointer;
                    span{
                        display: block;
                        color: #EF8412;
                        font-size: 16px;
                        text-align: center;
                    }
                }
            }
        }
    }
}
.zhe {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
}

.zhe .progress {
    position: fixed;
    width: 126px;
    height: 126px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 99999;
    color: #fff;
    /deep/.el-progress__text{
        color:#fff
    }
}
.legalTipsDia{
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/.el-dialog{
        margin-top: 0 !important;
        padding-bottom: 10px;
        vertical-align: middle;
        background-color: #FFF;
        border-radius: 4px;
        border: 1px solid #EBEEF5;
        font-size: 18px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        text-align: left;
        .el-dialog__header {
            padding: 15px 15px 10px;
        }
        .el-dialog__body{
            padding: 10px 15px;
        }
        .el-dialog__footer{
            padding: 0 20px;
        }
        .footer2{
            margin:10px auto;
            .agreement{
                a{
                    font-size: 14px;
                    color: #1890ff;
                }
            }
        }
    }
}
.diaForm{
    width: 525px;
    margin:0 auto;
    .tip{
        display: flex;
        justify-content: center;
        align-items: center;
        color:#F09135;
        text-align: center;
        margin-bottom: 20px;
        font-size: 16px;
        i{
            margin-right: 8px;
            font-size: 18px;
        }
    }
    .yzm-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .yzm-item .el-form-item {
        width: 350px;
    }
    .yzm-item span {
        width: 148px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background: #fff;
        color: #3f7df7;
        cursor: pointer;
        border: 1px solid #3f7df7;
        font-size: 14px;
        margin-top: 3px;
        border-radius: 3px;
    }
    .yzm-item span:hover {
        background: #3f7df7;
        color: #fff;
    }
    .yzm-item span[disabled] {
        color: #fff;
        background: #bcbcbc;
        pointer-events: none;
        cursor: inherit;
        border-color: #bcbcbc;
    }
    .footer{
        margin:10px auto;
        text-align: center;
        .agreement{
            a{
                font-size: 14px;
                color: #1890ff;
            }
        }
    }
}
</style>
